<template>
    <div :class="['event-action-container', event.hidden ? 'hidden-event-action-container' : '']">
        <div v-if="event.hidden" class="text-left">
            <v-chip label outlined color="#fb8c00" dark>Hidden</v-chip>
        </div>
        <nav class="event-action-tab-container">
            <li class="menu-entry" :class="nonLiveIndex == 0 && 'active'" @click="nonLiveIndex = 0">Recording</li>
            <li class="menu-entry" :class="nonLiveIndex == 1 && 'active'" @click="nonLiveIndex = 1">Health</li>
            <li class="menu-entry" :class="nonLiveIndex == 2 && 'active'" @click="nonLiveIndex = 2">Connection</li>
            <li class="menu-entry" :class="nonLiveIndex == 3 && 'active'" @click="nonLiveIndex = 3">Upload</li>
        </nav>

        <div class="event-action-tab-content">
            <!-- START: Default Tab -->
            <section v-if="nonLiveIndex === 0" class="default-button-container">
                <event-viewer class="p-4" :src="event.liveURL" :isLiveStream="true" :event="event" />
                <div style="display: flex; justify-content: center; gap: 1rem; margin-top: 1rem; flex-wrap: wrap">
                    <v-btn color="success" @click="handleResumeStream">Resume Stream</v-btn>
                    <v-btn color="warning" @click="warningLiveStreamEnd = true">End Stream</v-btn>
                </div>
            </section>
            <!-- END: Default Tab -->

            <!-- START: Health Tab -->
            <section v-if="nonLiveIndex === 1">
                <wowza-event-chart :live="event.eventStatus == 2" ref="wowzaChart" :event="event" />
            </section>
            <!-- END: Health Tab -->

            <!-- START: Connections Tab -->
            <section v-if="nonLiveIndex === 2">
                <ConnectionFields :connection="connection" :event="event" />
                <div v-if="this.streamingProvider === 1" style="display: flex; justify-content: center">
                    <qrcode-vue :value="qrValue" size="150" />
                </div>
            </section>
            <!-- END: Connections Tab -->

            <!-- START: Upload Tab -->
            <section v-if="nonLiveIndex === 3" class="">
                <div class="end-stream-container">
                    <h3 class="text-center">To upload a file you must first end the stream.</h3>
                    <p class="text-center">* Once a stream is ended you will not be able to start the stream again</p>
                    <v-btn large color="warning" @click="warningLiveStreamEnd = true">End Live Stream</v-btn>
                </div>
            </section>
            <!-- END: Upload Tab -->

            <!-- START: LIVE STREAM WARNING DIALOG -->
            <v-dialog v-model="warningLiveStreamEnd" persistent max-width="400">
                <v-card>
                    <v-card-title class="headline text-center"> </v-card-title>
                    <v-card-text>
                        <h1 class="text-center">Warning!</h1>
                        <p class="text-center">
                            Are you sure you want to end the live stream? You won't be able to start the stream again.
                        </p>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="warningLiveStreamEnd = false"> Cancel </v-btn>
                        <v-btn @click="endLiveStream" color="primary" text> Confirm </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- END: LIVE STREAM WARNING DIALOG -->
        </div>
    </div>
</template>

<script>
import WowzaEventChart from '@/components/charts/WowzaEventChart.vue';
import EventViewer from '@/components/videojs/EventViewer.vue';
import ConnectionFields from '@/components/ManageService/ConnectionFields.vue';
import QrcodeVue from 'qrcode.vue';

import { mapActions } from 'pinia';
import { useGlobalState } from '@/stores/globalState';

export default {
    props: {
        event: {
            type: Object,
            required: true,
        },
        service: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            qrValue: '',
            streamingProvider: '',
            nonLiveIndex: 0,
            wowzaChart: '',
            warningLiveStreamEnd: false,
            connection: {}, // Info about the connection such as RTMP Name etc.
        };
    },
    methods: {
        ...mapActions(useGlobalState, ['showSnackbar']),
        handleButtonClick: function () {
            this.$router.push({ path: `/services/upload/${this.event.id}` });
        },
        fetchConnections: function () {
            this.$auth.getIdTokenClaims().then(async result => {
                // Get Api Token
                this.token = result.__raw;

                // Make Request
                this.axios
                    .create({ headers: { Authorization: `Bearer ${this.token}` } })
                    .get(process.env.VUE_APP_API + `/live/${this.event.liveStreamId}`)
                    .then(response => {
                        this.connection = response.data;
                        this.assignQrValue();
                    });
            });
        },
        endLiveStream() {
            this.$auth.getIdTokenClaims().then(async result => {
                // Get Api Token
                this.token = result.__raw;

                this.axios
                    .create({ headers: { Authorization: `Bearer ${this.token}` } })
                    .post(process.env.VUE_APP_API + `/live/stop/${this.event.liveStreamId}`)
                    .then(response => {
                        this.$emit('refresh');
                        this.warningLiveStreamEnd = false;
                    })
                    .catch(error => {
                        this.showSnackbar({ message: 'Error Ending Live Stream', color: 'error' });
                    });
            });
        },
        handleResumeStream() {
            this.$auth.getIdTokenClaims().then(async result => {
                // Get Api Token
                this.token = result.__raw;

                this.axios
                    .create({ headers: { Authorization: `Bearer ${this.token}` } })
                    .post(process.env.VUE_APP_API + `/live/start/${this.event.liveStreamId}`)
                    .then(response => {
                        this.$emit('refresh');
                        this.warningLiveStreamEnd = false;
                    })
                    .catch(error => {
                        this.showSnackbar({ message: 'Error Ending Live Stream', color: 'error' });
                    });
            });
        },
        assignQrValue() {
            const username = this.connection.userName;
            const pass = this.connection.password;
            const streamName = this.connection.streamName;
            const newurl = encodeURIComponent(this.connection.primaryServer) + '/' + streamName;

            const QRCode = `larix://set/v1?conn[][url]=${newurl}&conn[][name]=${streamName}&conn[][mode]=av&conn[][user]=${username}&conn[][pass]=${pass}&conn[][target]=rtmp`;
            this.qrValue = QRCode;
        },
        getUserSettings() {
            return new Promise((resolve, reject) => {
                this.$auth.getIdTokenClaims().then(async result => {
                    // Get Api Token
                    this.token = result.__raw;

                    if (this.$auth.role.includes('SuperAdmin')) {
                        this.axios
                            .create({ headers: { Authorization: `Bearer ${this.token}` } })
                            .get(process.env.VUE_APP_API + `/funeralhomes/settings/admin/${this.event.funeralHomeId}`)
                            .then(response => {
                                if (response.data) {
                                    resolve(response.data);
                                }
                            })
                            .catch(error => {
                                this.$emit('message', error.response.data);
                                reject(error);
                            });
                    } else {
                        this.axios
                            .create({ headers: { Authorization: `Bearer ${this.token}` } })
                            .get(process.env.VUE_APP_API + `/funeralhomes/settings/${this.$auth.funeralHomeId}`)
                            .then(response => {
                                if (response.data) {
                                    resolve(response.data);
                                }
                            })
                            .catch(error => {
                                reject(error);
                            });
                    }
                });
            });
        },
    },
    components: {
        WowzaEventChart,
        EventViewer,
        ConnectionFields,
        QrcodeVue,
    },
    mounted() {
        if (this.event) {
            this.getUserSettings().then(response => {
                this.streamingProvider = response.streamingProvider;
            });
            this.fetchConnections();
        }
    },
};
</script>

<style lang="scss" scoped>
.event-action-tab-container {
    display: flex;
    margin-bottom: 1rem;
    justify-content: space-between;
    overflow-x: auto;

    .menu-entry {
        list-style: none;
        padding: 0.5rem 1rem;
        border-bottom: 4px solid rgba(0, 0, 0, 0);
        cursor: pointer;
    }

    .menu-entry.active {
        border-bottom: 4px solid rgb(78, 184, 226);
    }
}

.default-button-container {
    text-align: center;
}
.end-stream-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 3rem 1rem;
}
.text-center {
    text-align: center;
}
</style>
